import { SAPContact } from '../../types';

/** Compact contact summary stored in call-activity payloads (avoids full PII blobs). */
export interface CallLogContactSummary {
  id: string;
  name?: string;
  phone?: string;
  type?: SAPContact['type'];
  accountId?: string;
}

function contactDisplayName(contact: SAPContact): string | undefined {
  if (contact.type === 'corporate') {
    return contact.accountName?.trim() || undefined;
  }

  const name = `${contact.firstName ?? ''} ${contact.lastName ?? ''}`.trim();
  return name || undefined;
}

export function toCallLogContactSummary(contact: SAPContact): CallLogContactSummary {
  return {
    id: contact.id,
    name: contactDisplayName(contact),
    phone: contact.phone || undefined,
    type: contact.type,
    accountId: contact.accountId,
  };
}

export function toCallLogContactSummaries(contacts: SAPContact[]): CallLogContactSummary[] {
  return contacts.map(toCallLogContactSummary);
}
